<template>
  <div class="canvas">
    <canvas :id="id" :width="width" :height="height"></canvas>
  </div>
</template>

<script>
export default {
  name: "CanvasCircle",
  data() {
    return {}
  },
  props: {
    percent: {
      type: Number,
      default: 0
    },
    id: {
      type: String,
      default: "circle"
    },
    width: { //画布宽度
      type: Number,
      default: 100
    },
    height: { //画布高度
      type: Number,
      default: 100
    },
    radius: { // 圆环半径
      type: Number,
      default: 30
    },
    strokeWidth: { //圆环粗细
      type: Number,
      default: 8
    },
    lineCap: { // butt round square
      type: String,
      default: "butt"
    },
    colorOption: {
      type: Object,
      default: () => {
        return {
          startColor: "#00DBFF",
          endColor: ""
        }
      }
    }
  },
  mounted() {
    this.initCanvas(this.percent, this.radius, this.strokeWidth, this.lineCap, this.colorOption)
  },
  created() {},
  watch: {
    percent(newVal, oldVal) {
      if (newVal || newVal == 0) {
        this.isInit = false
        this.initCanvas(newVal, this.radius, this.strokeWidth, this.lineCap, this.colorOption)
      }
    }
  },
  methods: {
    initCanvas(percent, radius = 30, strokeWidth, lineCap, colorOption, offsetX = 0, offsetY = 0) {
      let canvas = document.getElementById(this.id)
      let context = canvas.getContext("2d")
      let x = canvas.width / 2 + offsetX
      let y = canvas.height / 2 + offsetY
      let startAngle = -Math.PI / 2
      let endAngle = 0;
          endAngle = percent * 2 * Math.PI - Math.PI / 2
      if (colorOption.endColor) {
        let ring = context.createLinearGradient(0, radius * 2, radius * 2, 0)
            ring.addColorStop("0", colorOption.startColor)
            ring.addColorStop("1.0", colorOption.endColor)
            context.strokeStyle = ring
      } else {
        context.strokeStyle = colorOption.startColor
      }
      context.lineWidth = strokeWidth
      context.clearRect(0, 0, canvas.width, canvas.width)
      context.beginPath();
      context.arc(x, y, radius, startAngle, endAngle)
      context.lineCap = lineCap
      context.stroke()
      context.closePath()
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/CanvasCircle/index.vue